import { DataContext } from "./../../context/DataContext";
import { Footer } from "./../../components/Footer/Footer";
import { Link } from "../../components/Link/link";
import { useResetScroll } from "./../../hooks/useResetScroll";
import React from "react";

import "./filters.scss";
import "./filter.scss";
import "./grid.scss";

const Filter = ({ term, className, onClick }) => {
	return (
		<div onClick={onClick} className={[`filter`, className].join(` `)}>
			{term.name}
		</div>
	);
};

const Filters = ({ terms, current, setCurrent }) => {
	return (
		<div className={`filters`}>
			{terms &&
				terms.length > 0 &&
				terms.map((term, index) => {
					return (
						term.count > 0 &&
						term.acf.visibility !== false && (
							<Filter
								className={`filter--${term.id === current ? `is-active` : `not-active`}`}
								key={index}
								onClick={() => setCurrent(term.id === current ? null : term.id)}
								term={term}
							/>
						)
					);
				})}
		</div>
	);
};

const Grid = ({ filter, term }) => {
	const projects = React.useContext(DataContext).projects;

	return (
		<div className={`grid`}>
			{projects &&
				projects.length > 0 &&
				projects.map(
					(project, index) =>
						(project[term].includes(filter) || !filter) && (
							<Link key={index} to={`/lavori/${project.slug}`} className={`grid-item`}>
								<div className={`grid-item-cover`}>
									<img
										src={project.acf.cover.immagine && project.acf.cover.immagine.sizes.large}
										alt={project.acf.cover.immagine.description}
									/>
								</div>
								<div className={`grid-item-caption`}>
									<p
										className={`_base centered`}
										dangerouslySetInnerHTML={{
											__html: project.acf.info.title || project.title.rendered,
										}}
									/>
								</div>
							</Link>
						)
				)}
		</div>
	);
};

export const Category = ({ term }) => {
	const terms = React.useContext(DataContext)[term];
	const [current, setCurrent] = React.useState();

	useResetScroll();

	return (
		<React.Fragment>
			<div className={`category`}>
				<Filters terms={terms} current={current} setCurrent={setCurrent} />
				<Grid filter={current} term={term} />
			</div>
			<Footer />
		</React.Fragment>
	);
};
